import { render, staticRenderFns } from "./zyList.vue?vue&type=template&id=2a13deed&scoped=true&"
import script from "./zyList.vue?vue&type=script&lang=js&"
export * from "./zyList.vue?vue&type=script&lang=js&"
import style0 from "./zyList.vue?vue&type=style&index=0&id=2a13deed&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a13deed",
  null
  
)

export default component.exports